import { useState, useEffect, useCallback } from 'react';
import { UserWallet, getUserWallet } from '../services/walletService';

interface UseWalletReturn {
  wallet: UserWallet | null;
  isLoading: boolean;
  error: Error | null;
  refetch: () => Promise<void>;
}

/**
 * Hook para obtener y gestionar los datos de la wallet del usuario
 * @param userId - ID del usuario autenticado
 */
export function useWallet(userId: string | undefined): UseWalletReturn {
  const [wallet, setWallet] = useState<UserWallet | null>(null);
  const [isLoading, setIsLoading] = useState(true); // Inicializar como true para evitar flash del banner
  const [error, setError] = useState<Error | null>(null);

  const fetchWallet = useCallback(async () => {
    if (!userId) {
      setWallet(null);
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const walletData = await getUserWallet(userId);
      setWallet(walletData);
    } catch (err) {
      console.error('Error fetching wallet:', err);
      setError(err instanceof Error ? err : new Error('Error fetching wallet'));
      setWallet(null);
    } finally {
      setIsLoading(false);
    }
  }, [userId]);

  // Cargar wallet cuando cambia el userId
  useEffect(() => {
    fetchWallet();
  }, [fetchWallet]);

  return {
    wallet,
    isLoading,
    error,
    refetch: fetchWallet
  };
}












